import { render, staticRenderFns } from "./MergeContactSummary.vue?vue&type=template&id=413f2a32&scoped=true"
import script from "./MergeContactSummary.vue?vue&type=script&lang=js"
export * from "./MergeContactSummary.vue?vue&type=script&lang=js"
import style0 from "./MergeContactSummary.vue?vue&type=style&index=0&id=413f2a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f2a32",
  null
  
)

export default component.exports